import { render, staticRenderFns } from "./FormUserWide.vue?vue&type=template&id=2f188bd1&"
import script from "./FormUserWide.vue?vue&type=script&lang=js&"
export * from "./FormUserWide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports